import { createStore } from 'vuex'

export const dataStatus = createStore({
  state: () => {
    return {
      statusModalOpen: false, 
      status: 'failed'
    }
  },
  getters: {
    modalOpen: (s) => s.statusModalOpen,
    status: (s) => s.status
  },
  mutations: {
    MODAL_OPEN(state, payload) {
      state.statusModalOpen = payload
    },
    SET_MODAL_STATUS(state, payload) {
      state.status = payload
    },
  },
  actions: {
    setModalOpen({ commit }, val) {
      commit('MODAL_OPEN', val);
    },
    setStatus({ commit }, value) {
      commit('SET_MODAL_STATUS', value);
    }
  }
})